import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const XPBar = ({ currentXP, maxXP, level, levelName, t, showMeta = true }) => {
  const reduceMotion = useReducedMotion();
  const percentage = maxXP > 0 ? Math.min((currentXP / maxXP) * 100, 100) : 100;
  const shouldPulse = !reduceMotion && percentage >= 95;

  return (
    <div className="w-full" data-testid="home-xp-progress">
      {showMeta && (
        <div className="flex justify-between items-center text-sm mb-1.5">
          <span className="font-bold text-[color:var(--cb-text)]">
            {t('level')} {level} - {levelName}
          </span>
          <span className="text-[color:var(--cb-text-muted)] font-semibold text-xs">
            {currentXP} / {maxXP} XP
          </span>
        </div>
      )}
      <motion.div
        key={`${level}-${Math.round(percentage)}`}
        animate={shouldPulse ? { scale: [1, 1.012, 1] } : { scale: 1 }}
        transition={shouldPulse ? { duration: 0.55, ease: 'easeInOut' } : { duration: 0 }}
        className="overflow-hidden"
        style={{ height: 8, borderRadius: 4, background: 'var(--color-surface)' }}
      >
        <motion.div
          className="h-full"
          style={{
            borderRadius: 4,
            background: 'linear-gradient(90deg, var(--color-primary), #D4A08A)',
          }}
          initial={{ width: 0 }}
          animate={{ width: `${percentage}%` }}
          transition={{ duration: 0.6, ease: 'easeOut', delay: 0.2 }}
        />
      </motion.div>
    </div>
  );
};

export default XPBar;
